import smartSolveApi from './instances/smartsolve';

export const validateToken = async (prevToken) => {
  try {
    const response = await smartSolveApi.post('/validatetoken', { prevToken });
    return response.data;
  } catch (e) {
    throw new Error(`validatetoken() failed: ${e}`);
  }
};
